import { Box, Skeleton } from '@factorialco/deprecated-design-system'

export const LoadingState = () => {
  return (
    <Box gap="s8">
      <Skeleton width="s200" height="s12" />
      <Skeleton width="s200" height="s12" />
      <Skeleton width="s200" height="s12" />
      <Skeleton width="s200" height="s12" />
    </Box>
  )
}

export const LoadingButton = () => {
  return (
    <Box flexDirection="row" gap="s8">
      <Skeleton width="s120" height="s32" />
    </Box>
  )
}
